export default {
	styleOverrides: {
		root: {
			fontSize: '18px',
			fontWeight: 600,
			lineHeight: '29px',
			letterSpacing: '0.4px',
		},
	},
};
